import cls from 'classnames';
import React from 'react';

import DialogFooterButton from '../../common/dialog-button';

export interface IProps {
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  value?: string;

  onPress?: () => void;
}

const DialogFooterOkButton: React.FC<React.PropsWithChildren<IProps>> = ({
  className: pClassName,
  disabled,
  value,
  loading,
  onPress
}) => {
  const className = React.useMemo(() => {
    return cls('btn', pClassName, { 'opacity-50 cursor-default': disabled });
  }, [pClassName, disabled]);

  return (
    <DialogFooterButton
      className={className}
      disabled={disabled}
      loading={loading}
      onPress={onPress}
    >
      {value}
    </DialogFooterButton>
  );
};

DialogFooterOkButton.defaultProps = {
  disabled: false,
  value: 'Ok'
};

export default DialogFooterOkButton;
